import { Component, Inject } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { RouterFacade } from '@cigna/shared/angular/core/router-state-data-access';

import {
  ENVIRONMENT_CONFIG,
  EnvironmentConfig,
} from '@cigna/chcp/shared/environment-util';
import { RouteData } from '@cigna/chcp/shared/util';
import { FeatureTogglesFacade } from '@cigna/shared/angular/features-feature';

@Component({
  selector: 'cigna-layout-public',
  templateUrl: './layout-public.component.html',
  styleUrls: ['./layout-public.component.scss'],
})
export class LayoutPublicComponent {
  routeData$ = this.routerFacade.data$ as Observable<RouteData>;
  isResourcePage$ = this.routeData$.pipe(
    map((data) => data.routeCode === 'resources'),
  );
  logoLink$ = this.isResourcePage$.pipe(
    map((isResourcePage) =>
      isResourcePage
        ? `${this.envConfig.api.gateways.cdn}assets/evernorth/provider/resourceLibrary/resourceLibrary.html`
        : '/login',
    ),
  );
  siteDownFlag$ = this.featureToggleFacade.featuresEnabled([
    'ftr-chcp-global-team-web-site_down',
  ]);
  hasOneTrustEnabled$ = this.featureToggleFacade.featuresEnabled([
    'ftr-chcp-global-team-web-onetrust',
  ]);

  constructor(
    private routerFacade: RouterFacade,
    private featureToggleFacade: FeatureTogglesFacade,
    @Inject(ENVIRONMENT_CONFIG) private envConfig: EnvironmentConfig,
  ) {}
}
